import { map } from 'lodash'

import { COMPONENT_INGREDIENT_TYPES } from '../../../common/constants'

const transformToUpdateIngredientComponentDetailsArgs = data => ({
  isWholeFood: data.isWholeFood,
  isVague: data.isVague,
  componentIngredients: [
    ...map(data.definiteIngredientIds, id => ({
      id,
      type: COMPONENT_INGREDIENT_TYPES.DEFINITE,
    })),
    ...map(data.probableIngredientIds, id => ({
      id,
      type: COMPONENT_INGREDIENT_TYPES.PROBABLE,
    })),
  ],
})

export default transformToUpdateIngredientComponentDetailsArgs
